module.exports = __webpack_public_path__ + "static/img/6-5.4c55b48.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/selection/pc/components/past-review/6-5.png
// module id = swRH
// module chunks = 25